module.exports = __webpack_public_path__ + "img/ardu.24024d45.jpg";